/////////////////////////////////////////////////////////
// Configurations related to listing.                  //
// Main configuration here is the extended data config //
/////////////////////////////////////////////////////////

// Note: The listingFields come from listingFields asset nowadays by default.
//       To use this built-in configuration, you need to change the overwrite from configHelper.js
//       (E.g. use mergeDefaultTypesAndFieldsForDebugging func)

/**
 * Configuration options for listing fields (custom extended data fields):
 * - key:                           Unique key for the extended data field.
 * - scope (optional):              Scope of the extended data can be either 'public' or 'private'.
 *                                  Default value: 'public'.
 *                                  Note: listing doesn't support 'protected' scope atm.
 * - schemaType (optional):         Schema for this extended data field.
 *                                  This is relevant when rendering components and querying listings.
 *                                  Possible values: 'enum', 'multi-enum', 'text', 'long', 'boolean'.
 * - enumOptions (optional):        Options shown for 'enum' and 'multi-enum' extended data.
 *                                  These are used to render options for inputs and filters on
 *                                  EditListingPage, ListingPage, and SearchPage.
 * - listingTypeConfig (optional):  Relationship configuration against listing types.
 *   - limitToListingTypeIds:         Indicator whether this listing field is relevant to a limited set of listing types.
 *   - listingTypeIds:                An array of listing types, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToListingTypeIds is true.
 * - categoryConfig (optional):     Relationship configuration against categories.
 *   - limitToCategoryIds:            Indicator whether this listing field is relevant to a limited set of categories.
 *   - categoryIds:                   An array of categories, for which this custom listing field is
 *                                    relevant and should be added. This is mandatory if limitToCategoryIds is true.
 * - filterConfig:                  Filter configuration for listings query.
 *    - indexForSearch (optional):    If set as true, it is assumed that the extended data key has
 *                                    search index in place. I.e. the key can be used to filter
 *                                    listing queries (then scope needs to be 'public').
 *                                    Note: Flex CLI can be used to set search index for the key:
 *                                    https://www.sharetribe.com/docs/references/extended-data/#search-schema
 *                                    Read more about filtering listings with public data keys from API Reference:
 *                                    https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
 *                                    Default value: false,
 *   - filterType:                    Sometimes a single schemaType can be rendered with different filter components.
 *                                    For 'enum' schema, filterType can be 'SelectSingleFilter' or 'SelectMultipleFilter'
 *   - label:                         Label for the filter, if the field can be used as query filter
 *   - searchMode (optional):         Search mode for indexed data with multi-enum schema.
 *                                    Possible values: 'has_all' or 'has_any'.
 *   - group:                         SearchPageWithMap has grouped filters. Possible values: 'primary' or 'secondary'.
 * - showConfig:                    Configuration for rendering listing. (How the field should be shown.)
 *   - label:                         Label for the saved data.
 *   - isDetail                       Can be used to hide detail row (of type enum, boolean, or long) from listing page.
 *                                    Default value: true,
 * - saveConfig:                    Configuration for adding and modifying extended data fields.
 *   - label:                         Label for the input field.
 *   - placeholderMessage (optional): Default message for user input.
 *   - isRequired (optional):         Is the field required for providers to fill
 *   - requiredMessage (optional):    Message for those fields, which are mandatory.
 */
export const listingFields = [
  // {
  //   "scope": "public",
  //   "label": "Gears",
  //   "key": "gears",
  //   "schemaType": "long",
  //   "numberConfig": {
  //     "minimum": 1,
  //     "maximum": 24
  //   },
  //   "filterConfig": {
  //     "indexForSearch": true,
  //     "group": "primary",
  //     "label": "Gears"
  //   }
  // }
  // {
  //   key: 'bikeType',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: 'city-bikes', label: 'City bikes' },
  //     { option: 'electric-bikes', label: 'Electric bikes' },
  //     { option: 'mountain-bikes', label: 'Mountain bikes' },
  //     { option: 'childrens-bikes', label: "Children's bikes" },
  //   ],
  //   categoryConfig: {
  //     limitToCategoryIds: true,
  //     categoryIds: ['cats'],
  //   },
  //   filterConfig: {
  //     indexForSearch: true,
  //     filterType: 'SelectMultipleFilter', //'SelectSingleFilter',
  //     label: 'Bike type',
  //     group: 'primary',
  //   },
  //   showConfig: {
  //     label: 'Bike type',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Bike type',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a bike type.',
  //   },
  // },
  // {
  //   key: 'tire',
  //   scope: 'public',
  //   schemaType: 'enum',
  //   enumOptions: [
  //     { option: '29', label: '29' },
  //     { option: '28', label: '28' },
  //     { option: '27', label: '27' },
  //     { option: '26', label: '26' },
  //     { option: '24', label: '24' },
  //     { option: '20', label: '20' },
  //     { option: '18', label: '18' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Tire size',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Tire size',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Tire size',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: true,
  //     requiredMessage: 'You need to select a tire size.',
  //   },
  // },
  {
    "key": "subcategory",
    "scope": "public",
    "schemaType": "enum",
    "enumOptions": [
      { "option": "bodysuits", "label": "Bodysuits" },
      { "option": "dresses", "label": "Dresses" },
      { "option": "dungarees", "label": "Dungarees & Rompers" },
      { "option": "fancy_dress", "label": "Fancy Dress" },
      { "option": "knitwear", "label": "Knitwear" },
      { "option": "leggings", "label": "Leggings" },
      { "option": "outerwear", "label": "Outerwear" },
      { "option": "pyjamas", "label": "Pyjamas" },
      { "option": "school_uniform", "label": "School Uniform" },
      { "option": "sets_outfits", "label": "Sets/Outfits" },
      { "option": "shorts", "label": "Shorts" },
      { "option": "skirts", "label": "Skirts" },
      { "option": "sleep_suits", "label": "Sleepsuits" },
      { "option": "swimwear", "label": "Swimwear" },
      { "option": "tops", "label": "Tops" },
      { "option": "trousers", "label": "Trousers" },
      { "option": "jeans", "label": "Jeans" },
      { "option": "boots_&_wellies", "label": "Boots & Wellies" },
      { "option": "first_shoes", "label": "First Shoes" },
      { "option": "occasion_shoes", "label": "Occasion Shoes" },
      { "option": "pre-walkers", "label": "Pre-walkers" },
      { "option": "sandals", "label": "Sandals" },
      { "option": "school_shoes", "label": "School Shoes" },
      { "option": "trainers", "label": "Trainers" },
      { "option": "hair_accessories", "label": "Hair Accessories" },
      { "option": "hats", "label": "Hats" },
      { "option": "scarves", "label": "Scarves" },
      { "option": "socks_&_tights", "label": "Socks & Tights" },
      { "option": "sunglasses", "label": "Sunglasses" },
      { "option": "action_figures", "label": "Action figures" },
      { "option": "bath_toys", "label": "Bath toys" },
      { "option": "beach_play", "label": "Beach play" },
      { "option": "creative_play", "label": "Creative play" },
      { "option": "dolls", "label": "Dolls" },
      { "option": "educational", "label": "Educational" },
      { "option": "electronic", "label": "Electronic" },
      { "option": "games_&_puzzles", "label": "Games & puzzles" },
      { "option": "imaginative_play", "label": "Imaginative play" },
      { "option": "music", "label": "Music" },
      { "option": "outdoor_toys", "label": "Outdoor toys" },
      { "option": "play_gyms", "label": "Play gyms" },
      { "option": "ride-ons", "label": "Ride-ons" },
      { "option": "soft_play", "label": "Soft play" },
      { "option": "soft_toys", "label": "Soft toys" },
      { "option": "teepees_tents_ball_pits", "label": "Teepees/tents/ball pits" },
      { "option": "bath", "label": "Bath" },
      { "option": "mealtime", "label": "Mealtime" },
      { "option": "nursery", "label": "Nursery" },
      { "option": "travel", "label": "Travel" },
      { "option": "beach_&_swimwear", "label": "Beach & Swimwear" },
      { "option": "nightwear_&_loungewear", "label": "Nightwear & Loungewear" },
      { "option": "nursing_bras", "label": "Nursing Bras" }
    ],
    "filterConfig": {
      "indexForSearch": true,
      "label": "Subcategory",
      "group": "primary"
    },
    "showConfig": {
      "label": "Subcategory",
      "isDetail": true
    },
    "saveConfig": {
      "label": "Subcategory",
      "placeholderMessage": "Select a category",
      "isRequired": true,
      "requiredMessage": "You need to select a category."
    }
  },
  {
    key: 'brand',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: "1+_in_the_family", label: "1+ in the family" },
      { option: "abercrombie", label: "Abercrombie" },
      { option: "acne", label: "Acne" },
      { option: "adidas", label: "Adidas" },
      { option: "aden_+_anais", label: "Aden + Anais" },
      { option: "amaia", label: "Amaia" },
      { option: "ando", label: "Ando" },
      { option: "another_fox", label: "Another Fox" },
      { option: "and_they_wear", label: "And They Wear" },
      { option: "a.p.c", label: "A.P.C" },
      { option: "arket", label: "Arket" },
      { option: "babiators", label: "Babiators" },
      { option: "balenciaga", label: "Balenciaga" },
      { option: "bambolina", label: "Bambolina" },
      { option: "bamboo_baby", label: "Bamboo Baby" },
      { option: "bebe_organic", label: "Bebe Organic" },
      { option: "benedita", label: "Benedita" },
      { option: "bellerose", label: "Bellerose" },
      { option: "bobo_choses", label: "Bobo Choses" },
      { option: "bobux", label: "Bobux" },
      { option: "bombas", label: "Bombas" },
      { option: "bonds", label: "Bonds" },
      { option: "bonnie_&_the_gang", label: "Bonnie & The Gang" },
      { option: "bonnie_mob", label: "Bonnie Mob" },
      { option: "bonton", label: "Bonton" },
      { option: "boy_london", label: "BOY London" },
      { option: "boss", label: "Boss" },
      { option: "burberry", label: "Burberry" },
      { option: "calvin_klein", label: "Calvin Klein" },
      { option: "canada_goose", label: "Canada Goose" },
      { option: "caramel", label: "Caramel" },
      { option: "caramelo_kids", label: "Caramelo Kids" },
      { option: "carter’s", label: "Carter’s" },
      { option: "cashmirino", label: "Cashmirino" },
      { option: "cat_&_jack", label: "Cat & Jack" },
      { option: "cath_kidston", label: "Cath Kidston" },
      { option: "champion", label: "Champion" },
      { option: "cotton_hill", label: "Cotton Hill" },
      { option: "charlotte_knowles", label: "Charlotte Knowles" },
      { option: "claude_&_co", label: "Claude & Co" },
      { option: "dkny", label: "DKNY" },
      { option: "dolce_and_gabbana", label: "Dolce and Gabbana" },
      { option: "dr_martens", label: "Dr Martens" },
      { option: "ergo_pouch", label: "Ergo Pouch" },
      { option: "etta_loves", label: "Etta Loves" },
      { option: "f&f_clothing", label: "F&F clothing" },
      { option: "falke", label: "Falke" },
      { option: "fat_face", label: "Fat Face" },
      { option: "floral_threads", label: "Floral Threads" },
      { option: "fin_&_vince", label: "Fin & Vince" },
      { option: "frugo", label: "Frugo" },
      { option: "fub", label: "Fub" },
      { option: "gap", label: "Gap" },
      { option: "gucci", label: "Gucci" },
      { option: "guess", label: "Guess" },
      { option: "hanna_andersson", label: "Hanna Andersson" },
      { option: "h&m", label: "H&M" },
      { option: "hatley", label: "Hatley" },
      { option: "hello_simone", label: "Hello Simone" },
      { option: "hope_like_a_bunny", label: "Hope Like A Bunny" },
      { option: "honest_baby", label: "Honest Baby" },
      { option: "i_dig_denim", label: "I Dig Denim" },
      { option: "if_only_if", label: "If only if" },
      { option: "il_gufo", label: "Il Gufo" },
      { option: "ina_swim", label: "Ina Swim" },
      { option: "isla_&_fraser", label: "Isla & Fraser" },
      { option: "izipizi", label: "Izipizi" },
      { option: "jacadi", label: "Jacadi" },
      { option: "jamie_kay", label: "Jamie Kay" },
      { option: "janie_&_jack", label: "Janie & Jack" },
      { option: "john_lewis", label: "John Lewis" },
      { option: "jojo_maman_bebe", label: "Jojo Maman Bebe" },
      { option: "joules", label: "Joules" },
      { option: "kidly", label: "Kidly" },
      { option: "kiso_apparel", label: "Kiso Apparel" },
      { option: "kissy_kissy", label: "Kissy Kissy" },
      { option: "kit_and_kin", label: "Kit and Kin" },
      { option: "kite", label: "Kite" },
      { option: "la_coqueta", label: "La Coqueta" },
      { option: "levis", label: "Levi’s" },
      { option: "liewood", label: "Liewood" },
      { option: "lindex", label: "Lindex" },
      { option: "little_bird", label: "Little Bird" },
      { option: "little_cotton_clothes", label: "Little Cotton Clothes" },
      { option: "little_green_radicals", label: "Little Green Radicals" },
      { option: "little_jax", label: "Little Jax" },
      { option: "mamas_&_papas", label: "Mamas & Papas" },
      { option: "m&s", label: "M&S" },
      { option: "marie-chantal", label: "Marie-Chantal" },
      { option: "mayoral", label: "Mayoral" },
      { option: "meri_meri", label: "Meri Meri" },
      { option: "merino_kids", label: "Merino Kids" },
      { option: "michael_kors", label: "Michael Kors" },
      { option: "mini_boden", label: "Mini Boden" },
      { option: "mini_rodini", label: "Mini Rodini" },
      { option: "moncler", label: "Moncler" },
      { option: "monkind", label: "Monkind" },
      { option: "moon_boot", label: "Moon Boot" },
      { option: "mori", label: "Mori" },
      { option: "mothercare", label: "Mothercare" },
      { option: "natural_baby_shower", label: "Natural Baby Shower" },
      { option: "naturino", label: "Naturino" },
      { option: "newbie", label: "Newbie" },
      { option: "next", label: "Next" },
      { option: "nights_by_wilder", label: "Nights By Wilder" },
      { option: "nike", label: "Nike" },
      { option: "numero_74", label: "Numero 74" },
      { option: 'oeuf_nyc', label: 'Oeuf NYC' },
      { option: 'olivier_london', label: 'Olivier London' },
      { option: 'organic_zoo', label: 'Organic Zoo' },
      { option: 'osh_kosh', label: 'Osh Kosh' },
      { option: 'patachou', label: 'Patachou' },
      { option: 'patagonia', label: 'Patagonia' },
      { option: 'pehr', label: 'Pehr' },
      { option: 'pepa_&_co.', label: 'Pepa & Co.' },
      { option: 'pepa_london', label: 'Pepa London' },
      { option: 'petit_bateau', label: 'Petit Bateau' },
      { option: 'phi_clothing', label: 'Phi Clothing' },
      { option: 'polarn_o._pyret', label: 'Polarn O. Pyret' },
      { option: 'posh_peanut', label: 'Posh Peanut' },
      { option: 'pure_baby', label: 'Pure Baby' },
      { option: 'quincy_mae', label: 'Quincy Mae' },
      { option: 'rachel_riley', label: 'Rachel Riley' },
      { option: 'ralph_lauren', label: 'Ralph Lauren' },
      { option: 'regina_pyo', label: 'Regina Pyo' },
      { option: 'reiss', label: 'Reiss' },
      { option: 'repose_ams', label: 'Repose AMS' },
      { option: 'rylee_+_cru', label: 'Rylee + Cru' },
      { option: 'scamp_&_dude', label: 'Scamp & Dude' },
      { option: 'self_portrait', label: 'Self Portrait' },
      { option: 'sisi_&_seb', label: 'Sisi & Seb' },
      { option: 'shushu/tong', label: 'Shushu/Tong' },
      { option: 'smallable', label: 'Smallable' },
      { option: 'stella_mccartney_kids', label: 'Stella McCartney Kids' },
      { option: 'studi_boheme', label: 'Studi Boheme' },
      { option: 'splash_about', label: 'Splash About' },
      { option: 'tartine_et_chocolat', label: 'Tartine et Chocolat' },
      { option: 'the_animals_observatory', label: 'The Animals Observatory' },
      { option: 'the_little_finery', label: 'The Little Finery' },
      { option: 'the_little_white_company', label: 'The Little White Company' },
      { option: 'the_simple_folk', label: 'The Simple Folk' },
      { option: 'the_row', label: 'The Row' },
      { option: 'teva', label: 'Teva' },
      { option: 'töastie', label: 'Töastie' },
      { option: 'toasties_', label: 'Toasties ' },
      { option: 'tommy_hilfiger', label: 'Tommy Hilfiger' },
      { option: 'trotters', label: 'Trotters' },
      { option: 'turtledove_london', label: 'Turtledove London' },
      { option: 'tuwi', label: 'Tuwi' },
      { option: 'uniqlo', label: 'Uniqlo' },
      { option: 'vans', label: 'Vans' },
      { option: 'veja', label: 'Veja' },
      { option: 'versace', label: 'Versace' },
      { option: 'vild_house_of_little', label: 'Vild House of Little' },
      { option: 'wander_and_wonder', label: 'Wander and Wonder' },
      { option: 'we_are_kids', label: 'We are Kids' },
      { option: 'weekend_house', label: 'Weekend House' },
      { option: 'wexbaby', label: 'Wexbaby' },
      { option: 'zara', label: 'Zara' },
      { option: 'zig_+_star', label: 'Zig + Star' },
      { option: 'ziggy_zaza', label: 'Ziggy Zaza' },
      { option: 'zimmerman', label: 'Zimmerman' },
      { option: 'a_pea_in_the_pod', label: 'A Pea in the Pod' },
      { option: 'asos', label: 'ASOS' },
      { option: 'ba&sh', label: 'Ba&sh' },
      { option: 'belly_bandit', label: 'Belly Bandit' },
      { option: 'bbhugme', label: 'Bbhugme' },
      { option: 'bellababy', label: 'BellaBaby' },
      { option: 'bellamoon', label: 'BellaMoon' },
      { option: 'beyond_nine', label: 'Beyond Nine' },
      { option: 'blanqi', label: 'Blanqi' },
      { option: 'boppy', label: 'Boppy' },
      { option: 'bump_&_milk', label: 'Bump & Milk' },
      { option: 'bumpsuit', label: 'Bumpsuit' },
      { option: 'dreamgenii', label: 'Dreamgenii' },
      { option: 'elvie', label: 'Elvie' },
      { option: 'frame', label: 'Frame' },
      { option: 'hatch', label: 'Hatch' },
      { option: 'isabella_oliver', label: 'Isabella Oliver' },
      { option: 'j_brand', label: 'J Brand' },
      { option: 'lansinoh', label: 'Lansinoh' },
      { option: 'lorna_jane', label: 'Lorna Jane' },
      { option: 'mamalicious', label: 'Mamalicious' },
      { option: 'mango', label: 'Mango' },
      { option: 'medela', label: 'Medela' },
      { option: 'modibodi', label: 'Modibodi' },
      { option: 'naked_wardrobe_mama', label: 'Naked Wardrobe Mama' },
      { option: 'natal_active', label: 'Natal Active' },
      { option: 'nobody’s_child', label: 'Nobody’s Child' },
      { option: 'pharmedoc', label: 'PharMeDoc' },
      { option: 'paige', label: 'Paige' },
      { option: 'seraphine', label: 'Seraphine' },
      { option: 'sezane', label: 'Sezane' },
      { option: 'skims', label: 'Skims' },
      { option: 'spectra', label: 'Spectra' },
      { option: 'storq', label: 'Storq' },
      { option: 'sweaty_betty', label: 'Sweaty Betty' },
      { option: 'topshop', label: 'Topshop' },
      { option: 'triumph', label: 'Triumph' },
      { option: 'queen_rose', label: 'Queen Rose' },
      { option: 'wednesdays_girl', label: 'Wednesday’s Girl' },
      { option: 'willow', label: 'Willow' },
      { option: 'other', label: 'Other' }
    ],
    filterConfig: {
      indexForSearch: true,
      label: 'Brand',
      group: 'secondary',
    },
    showConfig: {
      label: 'Brand',
      isDetail: true,
    },
    saveConfig: {
      label: 'Brand',
      placeholderMessage: 'Select an option…',
      isRequired: true,
      requiredMessage: 'You need to select a brand.',
    },
  },
  // {
  //   key: 'brandTitle',
  //   scope: 'public',
  //   schemaType: 'text',
  //   filterConfig: {
  //     indexForSearch: false,
  //     label: 'Brand',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Brand',
  //     isDetail: true,
  //   },
  //   saveConfig: {
  //     label: 'Brand',
  //     placeholderMessage: 'Add a brand',
  //     isRequired: true,
  //     requiredMessage: 'You need to a brand.',
  //   },
  // },
  {
    key: 'postalCode',
    scope: 'public',
    schemaType: 'text',
    filterConfig: {
      indexForSearch: false,
      label: 'postalCode',
      group: 'secondary',
    },
    showConfig: {
      label: 'Postal code',
      isDetail: true,
    },
    saveConfig: {
      label: 'Postal code',
      placeholderMessage: 'Select an option…',
      isRequired: true,
      requiredMessage: 'You need to add your postal code.',
    },
  },
  // {
  //   key: 'accessories',
  //   scope: 'public',
  //   schemaType: 'multi-enum',
  //   enumOptions: [
  //     { option: 'bell', label: 'Bell' },
  //     { option: 'lights', label: 'Lights' },
  //     { option: 'lock', label: 'Lock' },
  //     { option: 'mudguard', label: 'Mudguard' },
  //   ],
  //   filterConfig: {
  //     indexForSearch: true,
  //     label: 'Accessories',
  //     searchMode: 'has_all',
  //     group: 'secondary',
  //   },
  //   showConfig: {
  //     label: 'Accessories',
  //   },
  //   saveConfig: {
  //     label: 'Accessories',
  //     placeholderMessage: 'Select an option…',
  //     isRequired: false,
  //   },
  // },
  // // An example of how to use transaction type specific custom fields and private data.
  // {
  //   key: 'note',
  //   scope: 'public',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['product-selling'],
  //   },
  //   showConfig: {
  //     label: 'Extra notes',
  //   },
  //   saveConfig: {
  //     label: 'Extra notes',
  //     placeholderMessage: 'Some public extra note about this bike...',
  //   },
  // },
  // {
  //   key: 'privatenote',
  //   scope: 'private',
  //   schemaType: 'text',
  //   listingTypeConfig: {
  //     limitToListingTypeIds: true,
  //     listingTypeIds: ['daily-booking'],
  //   },
  //   saveConfig: {
  //     label: 'Private notes',
  //     placeholderMessage: 'Some private note about this bike...',
  //   },
  // },
];

///////////////////////////////////////////////////////////////////////
// Configurations related to listing types and transaction processes //
///////////////////////////////////////////////////////////////////////

// A presets of supported listing configurations
//
// Note 1: The listingTypes come from listingTypes asset nowadays by default.
//         To use this built-in configuration, you need to change the overwrite from configHelper.js
//         (E.g. use mergeDefaultTypesAndFieldsForDebugging func)
// Note 2: transaction type is part of listing type. It defines what transaction process and units
//         are used when transaction is created against a specific listing.

/**
 * Configuration options for listing experience:
 * - listingType:         Unique string. This will be saved to listing's public data on
 *                        EditListingWizard.
 * - label                Label for the listing type. Used as microcopy for options to select
 *                        listing type in EditListingWizard.
 * - transactionType      Set of configurations how this listing type will behave when transaction is
 *                        created.
 *   - process              Transaction process.
 *                          The process must match one of the processes that this client app can handle
 *                          (check src/util/transactions/transaction.js) and the process must also exists in correct
 *                          marketplace environment.
 *   - alias                Valid alias for the aforementioned process. This will be saved to listing's
 *                          public data as transctionProcessAlias and transaction is initiated with this.
 *   - unitType             Unit type is mainly used as pricing unit. This will be saved to
 *                          transaction's protected data.
 *                          Recommendation: don't use same unit types in completely different processes
 *                          ('item' sold should not be priced the same as 'item' booked).
 * - stockType            This is relevant only to listings using default-purchase process.
 *                        If set to 'oneItem', stock management is not showed and the listing is
 *                        considered unique (stock = 1).
 *                        Possible values: 'oneItem' and 'multipleItems'.
 *                        Default: 'multipleItems'.
 * - defaultListingFields These are tied to transaction processes. Different processes have different flags.
 *                        E.g. default-inquiry can toggle price and location to true/false value to indicate,
 *                        whether price (or location) tab should be shown. If defaultListingFields.price is not
 *                        explicitly set to _false_, price will be shown.
 *                        If the location or pickup is not used, listing won't be returned with location search.
 *                        Use keyword search as main search type if location is not enforced.
 *                        The payoutDetails flag allows provider to bypass setting of payout details.
 *                        Note: customers can't order listings, if provider has not set payout details! Monitor
 *                        providers who have not set payout details and contact them to ensure that they add the details.
 */

export const listingTypes = [
  {
    listingType: 'daily-booking',
    label: 'Daily booking',
    transactionType: {
      process: 'default-booking',
      alias: 'default-booking/release-1',
      unitType: 'day',
    },
    defaultListingFields: {
      location: true,
      payoutDetails: true,
    },
  },
  // // Here are some examples for other listingTypes
  // // TODO: SearchPage does not work well if both booking and product selling are used at the same time
  // {
  //   listingType: 'nightly-booking',
  //   label: 'Nightly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'night',
  //   },
  // },
  // {
  //   listingType: 'hourly-booking',
  //   label: 'Hourly booking',
  //   transactionType: {
  //     process: 'default-booking',
  //     alias: 'default-booking/release-1',
  //     unitType: 'hour',
  //   },
  // },
  // {
  //   listingType: 'product-selling',
  //   label: 'Sell bicycles',
  //   transactionType: {
  //     process: 'default-purchase',
  //     alias: 'default-purchase/release-1',
  //     unitType: 'item',
  //   },
  //   stockType: 'multipleItems',
  //   defaultListingFields: {
  //     shipping: true,
  //     pickup: true,
  //     payoutDetails: true,
  //   },
  // },
  // {
  //   listingType: 'inquiry',
  //   label: 'Inquiry',
  //   transactionType: {
  //     process: 'default-inquiry',
  //     alias: 'default-inquiry/release-1',
  //     unitType: 'inquiry',
  //   },
  //   defaultListingFields: {
  //     price: false,
  //     location: true,
  //   },
  // },
];

// SearchPage can enforce listing query to only those listings with valid listingType
// However, it only works if you have set 'enum' type search schema for the public data fields
//   - listingType
//
//  Similar setup could be expanded to 2 other extended data fields:
//   - transactionProcessAlias
//   - unitType
//
// Read More:
// https://www.sharetribe.com/docs/how-to/manage-search-schemas-with-flex-cli/#adding-listing-search-schemas
export const enforceValidListingType = false;
